export function estimateTotal(pricing, rooms, tier, addons) {
  if (!pricing || !tier || !pricing.tiers[tier]) return null;
  const mult = pricing.tiers[tier].multiplier;
  let subtotal = 0, area = 0, count = 0;
  rooms.filter((r) => r.included).forEach((r) => {
    const spec = pricing.room_types[r.type];
    if (!spec) return;
    const a = Number(r.area_sqft) || spec.default_area;
    area += a; count += 1;
    spec.items.forEach((i) => {
      subtotal += (i.unit === "sqft" ? i.rate * a : i.rate) * mult;
    });
  });
  addons.forEach((k) => {
    const ad = pricing.addons[k];
    if (!ad) return;
    subtotal += ad.unit === "sqft" ? ad.price * area : ad.unit === "unit" ? ad.price * Math.max(count, 1) : ad.price;
  });
  const fee = subtotal * pricing.design_fee_pct;
  return Math.round((subtotal + fee) * (1 + pricing.gst_pct));
}

export const addonLabelPrice = (a) => (a.unit === "sqft" ? `₹${a.price.toLocaleString("en-IN")}/sq.ft` : a.unit === "unit" ? `₹${a.price.toLocaleString("en-IN")}/room` : `₹${a.price.toLocaleString("en-IN")}`);

export const PRESETS = {
  "1 BHK": [["Living Room", "living", 200], ["Modular Kitchen", "kitchen", 80], ["Master Bedroom", "master_bedroom", 150], ["Bathroom", "bathroom", 40]],
  "2 BHK": [["Living Room", "living", 230], ["Dining Area", "dining", 110], ["Modular Kitchen", "kitchen", 100], ["Master Bedroom", "master_bedroom", 170], ["Bedroom 2", "bedroom", 140], ["Bathroom 1", "bathroom", 45], ["Bathroom 2", "bathroom", 40], ["Balcony", "balcony", 50]],
  "3 BHK": [["Living Room", "living", 280], ["Dining Area", "dining", 130], ["Modular Kitchen", "kitchen", 120], ["Master Bedroom", "master_bedroom", 190], ["Bedroom 2", "bedroom", 150], ["Kids Room", "kids_room", 130], ["Bathroom 1", "bathroom", 50], ["Bathroom 2", "bathroom", 45], ["Bathroom 3", "bathroom", 40], ["Balcony", "balcony", 60], ["Foyer / Entrance", "foyer", 40]],
};

export const presetRooms = (key) =>
  PRESETS[key].map(([name, type, area_sqft]) => ({ name, type, area_sqft, included: true }));
